import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const cmsBlockFn = /* @__PURE__ */ createRecipe('cms-block', {}, [])

const cmsBlockVariantMap = {
  "layout": [
    "stack",
    "grid",
    "gridItem"
  ],
  "marginBlockStart": [
    "none",
    "tightest",
    "tighter",
    "default",
    "loose",
    "looser",
    "layout.looser",
    "layout.vast.default",
    "layout.vast.loose",
    "-tightest",
    "-tighter",
    "-default",
    "-loose",
    "-looser",
    "-layout.looser",
    "-layout.vast.default",
    "-layout.vast.loose"
  ],
  "marginBlockEnd": [
    "none",
    "tightest",
    "tighter",
    "default",
    "loose",
    "looser",
    "layout.looser",
    "layout.vast.default",
    "layout.vast.loose",
    "-tightest",
    "-tighter",
    "-default",
    "-loose",
    "-looser",
    "-layout.looser",
    "-layout.vast.default",
    "-layout.vast.loose"
  ],
  "marginInlineStart": [
    "none",
    "tightest",
    "tighter",
    "default",
    "loose",
    "looser",
    "layout.looser",
    "layout.vast.default",
    "layout.vast.loose",
    "-tightest",
    "-tighter",
    "-default",
    "-loose",
    "-looser",
    "-layout.looser",
    "-layout.vast.default",
    "-layout.vast.loose"
  ],
  "marginInlineEnd": [
    "none",
    "tightest",
    "tighter",
    "default",
    "loose",
    "looser",
    "layout.looser",
    "layout.vast.default",
    "layout.vast.loose",
    "-tightest",
    "-tighter",
    "-default",
    "-loose",
    "-looser",
    "-layout.looser",
    "-layout.vast.default",
    "-layout.vast.loose"
  ],
  "paddingBlockStart": [
    "none",
    "tightest",
    "tighter",
    "default",
    "loose",
    "looser",
    "layout.looser",
    "layout.vast.default",
    "layout.vast.loose"
  ],
  "paddingBlockEnd": [
    "none",
    "tightest",
    "tighter",
    "default",
    "loose",
    "looser",
    "layout.looser",
    "layout.vast.default",
    "layout.vast.loose"
  ],
  "paddingInlineStart": [
    "none",
    "tightest",
    "tighter",
    "default",
    "loose",
    "looser",
    "layout.looser",
    "layout.vast.default",
    "layout.vast.loose"
  ],
  "paddingInlineEnd": [
    "none",
    "tightest",
    "tighter",
    "default",
    "loose",
    "looser",
    "layout.looser",
    "layout.vast.default",
    "layout.vast.loose"
  ],
  "gap": [
    "none",
    "tightest",
    "tighter",
    "default",
    "loose",
    "looser",
    "layout.looser",
    "layout.vast.default",
    "layout.vast.loose"
  ],
  "textAlign": [
    "left",
    "center",
    "right",
    "inherit"
  ],
  "backgroundColor": [
    "bg.neutral",
    "bg.softest",
    "gray.800",
    "bg.accent.brand.hero-fixed",
    "blue.100",
    "aqua.100",
    "green.100",
    "orange.100",
    "purple.100",
    "red.400",
    "yellow.300",
    "teal.600",
    "blue.900",
    "orange.600",
    "aqua.800",
    "green.800",
    "purple.800",
    "red.800",
    "yellow.800"
  ],
  "maxWidth": [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "full"
  ],
  "gridTemplateColumns": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12"
  ],
  "gridColumnEnd": [
    "span1",
    "span2",
    "span3",
    "span4",
    "span5",
    "span6",
    "span7",
    "span8",
    "span9",
    "span10",
    "span11",
    "span12"
  ],
  "justifyContent": [
    "flex-start",
    "flex-end",
    "center",
    "stretch",
    "start",
    "end",
    "space-between",
    "auto"
  ],
  "alignItems": [
    "flex-start",
    "flex-end",
    "center",
    "stretch",
    "start",
    "end",
    "space-between",
    "auto"
  ],
  "alignSelf": [
    "flex-start",
    "flex-end",
    "center",
    "stretch",
    "start",
    "end",
    "space-between",
    "auto"
  ],
  "justifySelf": [
    "flex-start",
    "flex-end",
    "center",
    "stretch",
    "start",
    "end",
    "space-between",
    "auto"
  ],
  "order": [
    "0",
    "1",
    "2",
    "3"
  ],
  "borderTopLeftRadius": [
    "none",
    "sm",
    "md",
    "lg",
    "pill"
  ],
  "borderTopRightRadius": [
    "none",
    "sm",
    "md",
    "lg",
    "pill"
  ],
  "borderBottomRightRadius": [
    "none",
    "sm",
    "md",
    "lg",
    "pill"
  ],
  "borderBottomLeftRadius": [
    "none",
    "sm",
    "md",
    "lg",
    "pill"
  ]
}

const cmsBlockVariantKeys = Object.keys(cmsBlockVariantMap)

export const cmsBlock = /* @__PURE__ */ Object.assign(memo(cmsBlockFn.recipeFn), {
  __recipe__: true,
  __name__: 'cmsBlock',
  __getCompoundVariantCss__: cmsBlockFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: cmsBlockVariantKeys,
  variantMap: cmsBlockVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, cmsBlockVariantKeys)
  },
  getVariantProps: cmsBlockFn.getVariantProps,
})